/* tslint:disable */
/* eslint-disable */
/**
 * Simple API with JWT Auth
 * A minimal OpenAPI spec with JWT authentication and simple models.
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { updateIsDeleted, isDeleted, isNew, updateIsNew } from "@/api/util";
import { registerMeta } from "@/api/meta";
import {
  propertyMeta,
  typeMeta,
  typeMetaEnum,
  MetaTypesBase,
  EnumMetaType,
  MetaType,
  MetaTypeBase,
  PropertyMeta,
  AssignOptions,
  AssignOptionsRequired,
  FilterVarsType,
  getAssignOptions,
} from "../common";

/**
 *
 * @export
 * @enum {string}
 */

export const ReportStatus = {
  NotResolvable: "NOT_RESOLVABLE",
  Unresolved: "UNRESOLVED",
  ResolvedAutomatically: "RESOLVED_AUTOMATICALLY",
  ResolvedManually: "RESOLVED_MANUALLY",
} as const;

export type ReportStatus = (typeof ReportStatus)[keyof typeof ReportStatus];

export type ReportStatusEnumType = typeof ReportStatus;
export type ReportStatusOptional = ReportStatus;
export type ReportStatusTrackedI = ReportStatus;
export type ReportStatusTracked = ReportStatus;
export type ReportStatusMetaI = EnumMetaType<
  ReportStatusEnumType,
  ReportStatus
>;
export const ReportStatusMeta = typeMetaEnum<
  ReportStatusEnumType,
  ReportStatus
>("ReportStatus", ReportStatus);
export function transformDatesReportStatus(model: ReportStatus) {}

import { transformDatesMap } from "@/api/mappers/dtoDateMapper";
